import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ProductSelectFilterModule} from "../../../../product/api/component/product-select-filter/product-select-filter.module";
import {FormArrayInputModule} from "../../../../../components/common/form-array/form-array-input/form-array-input.module";
import {SaleSaveProductFormComponent} from "./sale-save-product-form.component";
import {FormFieldModule} from "../../../../core/component/form-field/form-field.module";
import {NumberInputModule} from "../../../../../components/common/number/number-input/number-input.module";
import {AmountInputModule} from "../../../../../components/common/amount/amount-input/amount-input.module";
import {CardModule} from "../../../../core/component/card/card.module";
import {ButtonModule} from "../../../../core/component/button/button.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FormArrayInputModule,
        ProductSelectFilterModule,
        FormFieldModule,
        NumberInputModule,
        AmountInputModule,
        CardModule,
        ButtonModule,
    ],
    declarations: [SaleSaveProductFormComponent],
    exports: [
        SaleSaveProductFormComponent
    ]
})
export class SaleSaveProductFormModule {
}
